module.exports = __webpack_public_path__ + "static/media/movies-header.361ada90.svg";